var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Hotplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3v70h58V3H9zm54 66H13V59h50v10zm0-14H13V7h50v48zm-4 11h-4v-4h4v4zm-9.38-13.67a10 10 0 100-20 10 10 0 000 20zm0-16a6 6 0 110 12 6 6 0 010-12zm-8.77-16.87a9 9 0 1117.999 0 9 9 0 01-17.999 0zM52 66h-4v-4h4v4zm-16 0H17v-4h19v4zm-9.62-36.54a10 10 0 100-20 10 10 0 000 20zm0-16a6 6 0 110 12 6 6 0 010-12zm8.77 28.87a9 9 0 11-17.999 0 9 9 0 0117.999 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Hotplate.0aeb4814.svg";
export { SvgD1Hotplate as ReactComponent };